// Presets v1 — atalhos pros casos mais comuns do Banco de Questões.
// Click num preset pré-preenche o filtro custom; usuário ainda pode editar.

export const PRESETS = [
  {
    id: 'ineditas-bncc',
    label: 'Inéditas BNCC',
    description: 'Questões nunca usadas em caderno, das etapas BNCC (2º/5º/9º EF)',
    filters: { ineditas: 'true', etapa: ['ano_2_ef', 'ano_5_ef', 'ano_9_ef'] }
  },
  {
    id: 'manuais-sem-uso',
    label: 'Sem uso',
    description: 'Questões que nunca entraram num caderno',
    filters: { ineditas: 'true' }
  },
  {
    id: 'serie-3-em',
    label: '3ª série EM',
    description: 'Todas as questões da matriz SAEB 2001-2023',
    filters: { etapa: ['serie_3_em'] }
  },
  {
    id: 'usadas-em-provas',
    label: 'Usadas em provas',
    description: 'Questões reaproveitáveis de cadernos tipo prova',
    filters: { usadas_em: ['exam'] }
  }
];
